import './createCategory.css'; 
import { useState } from 'react';
import CategoryIcons from '../../../../assets/categoryIcons/categoryIcons';
import SpacerBar from '../../../../components/spacerBar/spacerBar';
import MobileArrow from '../../../../assets/icons/navigationIcons/mobileArrow/mobileArrow';
import LoadingLogo from '../../../../components/loadingLogo/loadingLogo';


const colors = ['#8CE68C', '#88CDF6', '#F68888', '#F688E9', '#AE88F6', '#F6F688', '#F6C388', '#88F6EE', '#88A6F6', '#88F6D0'];


export default function CreateCategory() {

    const [isLoading, setIsLoading] = useState(false);
    const [categoryCreated, setCategoryCreated] = useState(false);

    const [iconIndex, setIconIndex] = useState(1);
    const [iconColor, setIconColor] = useState(0);
    

    const [categoryForm, setCategoryForm] = useState({
        expense_name: '',
        expense_svg_icon: iconIndex,
        expense_svg_color: colors[iconColor],
        expense_description: ''

   });

   const nameChange = (e) => {
        setCategoryForm((prev) => ({
            ...prev,             
            expense_name: e.target.value
        }));
   };

    const rightClick = () => {
        const nextIndex = (iconIndex + 1) % 32;

        setIconIndex(nextIndex);
        setCategoryForm((prev) => ({
            ...prev,             
            expense_svg_icon: nextIndex 
        }));
    };

    const leftClick = () => {
        const nextIndex = (iconIndex - 1 + 32) % 32;

        setIconIndex(nextIndex);
        setCategoryForm((prev) => ({
            ...prev,             
            expense_svg_icon: nextIndex 
        }));
    };

    const rightColorChange = () => {
        const nextIndex = (iconColor + 1) % 10;

        setIconColor(nextIndex);
        setCategoryForm((prev) => ({
            ...prev,             
            expense_svg_color: colors[nextIndex] 
        }));
    };

    const leftColorChange = () => {
        const nextIndex = (iconColor - 1 + 10) % 10;

        setIconColor(nextIndex);
        setCategoryForm((prev) => ({
            ...prev,             
            expense_svg_color: colors[nextIndex] 
        }));
    };

    const desChange = (e) => {
        setCategoryForm((prev) => ({
            ...prev,             
            expense_description: e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!categoryForm.expense_name) {
            alert('please enter a name for the category')
            return;
        }

        if (!categoryForm.expense_description) {
            alert('please enter a dexcription for the category')
            return;
        }

        
        try {
            setIsLoading(true);
            const res = await fetch('/fastapi/api/add_category', {
                method: 'POST',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_name: categoryForm.expense_name,
                    expense_svg_icon: categoryForm.expense_svg_icon,
                    expense_svg_color: categoryForm.expense_svg_color,
                    expense_description: categoryForm.expense_description,
                })
            },
        
        )
            setIsLoading(false);
            setCategoryCreated(true);
            if (!res.ok) {
                throw new Error('Failed to create category');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Expense category created successfully!');
            window.location.reload();
        }
        catch (error) {
            console.error('Error submitting category:', error);
            alert('Error adding category. Please try again.');
        }
    };

    if (categoryCreated) {
            return (
                <div className="no-access">
                          <LoadingLogo/>
                          <p style={{ color: 'red' }}>Category created</p>
                          {/* I want to change this to just clear the container and plop you on the page instead of reload in the browser */}
                          <a href="http://0.0.0.0:3001/expense" className="no-access-button">Create another Category</a>
                        </div>
            )
        }

    return (
        <div className="">
            <div className="create-category">
                <div>
                    <p>Create a Category:</p>
                </div>
                <div className="create-category-container">
                    <div className="category-form-container">
                        <form autoComplete='off' className="category-form">

                            <div className="category-form-header">
                                <div>
                                    <label>Category Name:</label>
                                    <input className="input-name" placeholder="Enter category..." value={categoryForm.expense_name} onChange={nameChange} required   />
                                </div>
                                <SpacerBar width='90%' center="auto"/>
                            </div>
                            <div>
                                <p className="temp-space">Create your Icon:</p>
                                <div className="icon-creator">
                                    <div className="input-svg-icon">
                                        <MobileArrow className="arrow-size" onClick={leftClick}/>
                                        <p>Icon</p>
                                        <MobileArrow  rotate='180' className="arrow-size" onClick={rightClick}/>
                                    </div>

                                    <div className="input-svg-icon"><CategoryIcons indexIcon={categoryForm.expense_svg_icon} expenseColor={categoryForm.expense_svg_color} className='category-form-icon'/></div>

                                    <div className="input-svg-icon">
                                        <MobileArrow className="arrow-size" onClick={leftColorChange}/>
                                        <p>Color</p>
                                        <MobileArrow  rotate='180' className="arrow-size" onClick={rightColorChange}/>
                                    </div>
                                </div>
                            </div>

                            <div className="category-description">
                            <SpacerBar width='90%' center="auto"/>
                                <label>Category Description:</label>           
                                <textarea
                                    className="expense-notes" 
                                    placeholder='Expense Description...'
                                    name="expense_details"
                                    value={categoryForm.expense_description}
                                    onChange={desChange}   
                                    required       
                                ></textarea>
                            </div>

                            <button className="button" onClick={handleSubmit}>submit</button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}